import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      meta: { title: '首页' },
      component: () => import('../views/home/Index.vue')
    },
    {
      path: '/goods-list',
      name: 'goods-list',
      meta: { title: '资源列表' },
      props: route => ({
        params: route.query.params
      }),
      component: () => import('../views/list/GoodsListTr.vue')
    },
    {
      path: '/goods-details',
      name: 'goods-details',
      meta: {
        title: '资源详情',
        orderType: 1
      },
      props: route => ({ id: route.query.id }),
      component: () => import('../views/goods/GoodsDetails.vue')
    },
    {
      path: '/buy',
      name: 'buy',
      meta: { title: '购买资源' },
      component: () => import('../views/buy/Index.vue')
    },
    {
      path: '/order',
      name: 'order',
      meta: { title: '订单' },
      props: route => ({ state: route.query.state }),
      component: () => import('../views/order/OrderIndex.vue')
    },
    {
      path: '/order-details',
      name: 'order-details',
      meta: { title: '订单详情' },
      props: route => ({ orderId: route.query.orderCode }),
      component: () => import('../views/order/OrderDetails.vue')
    },
    {
      path: '/order-implement',
      name: 'order-implement',
      meta: { title: '实施反馈' },
      props: route => ({ orderId: route.query.orderCode }),
      component: () => import('../views/order/OrderImplement.vue')
    },
    {
      path: '/pay',
      name: 'pay',
      meta: { title: '支付订单' },
      props: route => ({ orderNo: route.query.orderNo }),
      component: () => import('../views/buy/Pay.vue')
    },
    {
      path: '/conduct-pay',
      name: 'conduct-pay',
      meta: { title: '支付中' },
      component: () => import('../views/buy/ConductPay.vue')
    },
    {
      path: '/pay-result',
      name: 'pay-result',
      meta: { title: '支付结果' },
      props: route => ({ orderNo: route.query.orderNo }),
      component: () => import('../views/buy/PayResult.vue')
    },
    {
      path: '/cart',
      name: 'carts',
      meta: { title: '购物车' },
      component: () => import('../views/cart/Carts.vue')
    },
  ]
})

// 浏览器标题
router.beforeEach((to, from, next) => {
  document.title = to.meta.title + ' - ' + '供应商门户'
  next()
})

// 进入页面重置滑轮位置
router.afterEach((to, from) => {
  if (to.name !== from.name) {
    window.scrollTo(0, 0)
  }
  if (to.name === 'goods-details') {
    window.scrollTo(0, 0)
  }
})

export default router
